module.exports = __webpack_public_path__ + "img/myapp-en.f7598983.png";